import React from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import localize from '@Components/localize';
import ContentHead from '@Components/customComponents/ContentHead';
import { navigateTo } from '@Services/navigation';

const PermissionDenied = ({translate}) => {
	const navigate = useNavigate();

	const handleGoBack = () => {
		navigate(-1);
	};

	return (
		<div className="content">
			<div className="content__header flex--row_center-between paddings--sides_40">
				<div className="flex--row_center-left column-gap_20">
					<span onClick={handleGoBack} className="button-grey flex--row_center-center width--px_40 paddings--all_none">
						<i className="icon-menu icon--arrow-back"/>
					</span>
					<span onClick={() => navigateTo('transactions')} className="button-grey flex--row_center-center width--px_40 paddings--all_none">
						<i className="icon-menu icon--dashboard"/>
					</span>
			
				</div>
				<ContentHead />
			</div>
			<h1 className="error-page__title">403</h1>
			<h2 className="error-page__subtitle">
				{translate('permission_denied_title')}
			</h2>
			<p className="error-page__text">
				{translate('permission_denied_text') }
			</p>
		</div>
	)
}

PermissionDenied.propTypes = {
	translate: PropTypes.func,
};


export default localize(PermissionDenied);